import { render, staticRenderFns } from "./toaster.vue?vue&type=template&id=5a61544b&scoped=true&"
import script from "./toaster.vue?vue&type=script&lang=js&"
export * from "./toaster.vue?vue&type=script&lang=js&"
import style0 from "./toaster.vue?vue&type=style&index=0&id=5a61544b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61544b",
  null
  
)

export default component.exports